<template>
  <div class="row">
    <div class="col-12">
      <h4 class="text-center mb-3">Empresas</h4>
      <DataTable
        :value="companies"
        :lazy="true"
        :paginator="true"
        :rows="10"
        :loading="loading"
        :total-records="total_companies"
        class="p-datatable-gridlines p-datatable-sm"
        data-key="id"
        :row-hover="true"
        ref="datatable"
        @page="onPage($event)"
        @sort="onSort($event)"
      >
        <template #empty> Nenhum resultado </template>
        <template #loading> Carregando </template>
        <Column field="name" header="Nome"></Column>
        <Column field="cnpj" header="CNPJ"></Column>
        <Column>
          <template #body="slotProps">
            <div class="d-flex flex-nowrap justify-content-end">
              <router-link :to="'/companies/edit/' + slotProps.data.id">
                <button class="btn btn-warning ml-3">
                  <font-awesome-icon
                    :icon="['fas', 'wrench']"
                  ></font-awesome-icon>
                </button>
              </router-link>

              <button
                class="btn btn-danger ml-3"
                @click="onDelete(slotProps.data.company_id, slotProps.index)"
              >
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
              </button>
            </div>
          </template>
        </Column>
      </DataTable>

      <router-link to="/companies/create" class="btn btn-dark mt-3">
        <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
        Nova empresa
      </router-link>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted } from 'vue'

  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'

  import useCompany from '@/modules/Company.js'
  import useSwal from '@/modules/Swal.js'

  export default {
    components: {
      DataTable,
      Column,
    },
    setup() {
      const page = ref(1)
      const per_page = ref(10)
      const datatable = ref(null)

      const {
        companies,
        total_companies,
        loading,
        listCompanies,
        destroyCompany,
      } = useCompany()

      const onPage = (event) => {
        page.value = event.page + 1

        listCompanies(page.value, per_page.value)
      }

      const { showConfirmDeletionSwal } = useSwal()

      onMounted(async () => {
        await listCompanies(page.value, per_page.value)
      })

      return {
        loading,
        datatable,
        total_companies,
        companies,
        onPage,
        destroyCompany,
        showConfirmDeletionSwal,
      }
    },
    methods: {
      onDelete(company_id, index) {
        this.showConfirmDeletionSwal()
          .then((response) => {
            if (response.isConfirmed) {
              this.destroyCompany(company_id, index)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
    },
  }
</script>
